import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';

const PATREON_AUTH_URL = 'https://us-central1-mygmtracker.cloudfunctions.net/patreonAuth';

export default function AccessRequired() {
  const [user] = useAuthState(auth);

  const handlePatreonLink = () => {
    const url = PATREON_AUTH_URL + '?state=' + (user ? user.uid : '');
    window.location.href = url;
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <img
        src={process.env.PUBLIC_URL + '/logo-header.png'}
        alt="GM Rivalry Engine"
        style={{ height: '60px', marginBottom: '40px', opacity: 0.9 }}
      />

      <div style={{
        background: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '12px',
        padding: '40px',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '16px' }}>🔒</div>

        <div style={{
          fontFamily: "'Anton', sans-serif",
          fontSize: '1.4rem',
          letterSpacing: '3px',
          color: '#d4af37',
          marginBottom: '12px',
        }}>
          RESTRICTED ACCESS 
        </div>

        <p style={{
          fontFamily: "'Monda', sans-serif",
          fontSize: '0.75rem',
          color: 'rgba(255,255,255,0.5)',
          lineHeight: '1.7',
          marginBottom: '8px',
        }}>
          GM Rivalry Engine is reserved to Patreon members.
        </p>
        <p style={{
          fontFamily: "'Monda', sans-serif",
          fontSize: '0.75rem',
          color: 'rgba(255,255,255,0.5)',
          lineHeight: '1.7',
          marginBottom: '32px',
        }}>
          Link your Patreon to get access to the App.
        </p>

        <button
          onClick={handlePatreonLink}
          style={{
            width: '100%',
            padding: '14px',
            background: 'rgba(255,66,0,0.15)',
            border: '1px solid rgba(255,66,0,0.5)',
            borderRadius: '6px',
            color: '#ff4200',
            fontFamily: "'Anton', sans-serif",
            fontSize: '0.9rem',
            letterSpacing: '2px',
            cursor: 'pointer',
            marginBottom: '16px',
            transition: 'background 0.2s, border-color 0.2s, color 0.2s',
          }}
          onMouseEnter={function(e) {
            e.currentTarget.style.background = 'rgba(255,66,0,0.25)';
            e.currentTarget.style.borderColor = '#ff4200';
          }}
          onMouseLeave={function(e) {
            e.currentTarget.style.background = 'rgba(255,66,0,0.15)';
            e.currentTarget.style.borderColor = 'rgba(255,66,0,0.5)';
          }}
        >
          LINK YOUR PATREON ACCOUNT
        </button>

        <a
          href="https://www.patreon.com/TheImmortal21"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontFamily: "'Monda', sans-serif",
            fontSize: '0.6rem',
            color: 'rgba(255,255,255,0.25)',
            textDecoration: 'none',
            letterSpacing: '1px',
          }}
        >
          Not a member yet ? Get it on Patreon
        </a>
      </div>

      <div style={{
        marginTop: '24px',
        fontFamily: "'Monda', sans-serif",
        fontSize: '0.55rem',
        color: 'rgba(255,255,255,0.15)',
        letterSpacing: '1px',
      }}>
        {user ? 'Sign As ' + user.email : ''}
      </div>
    </div>
  );
}
